$(function () {
  
});
$(window).on('load', function(){
aboutpage_link();
setTimeout(function(){
message_gift();
},500);
});

function message_gift() {
if($('.gift-select-box').length) {
var url = $(location).attr('href');
if (url.indexOf("store.meguminosato.co.jp/products/") >= 0) {
if($('.shopify-payment-button').data('shopify') === 'payment-button'){
$('.shopify-payment-button').css('display','none');
}
}
}
};

function aboutpage_link() {
var current_heading = $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__heading').text();
var current_href = $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href');
  //console.log(current_heading);
  //console.log(current_href);
  if (current_heading.startsWith('JFS')) {
    $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').css('display','none');
  }
  if(current_href === '/pages/aboutpage'){
    if(current_heading === '栄農人'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/energee');
    }
    else if(current_heading === '一九六農園'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/ikutama-mi');
    }
    else if(current_heading === '久保農園'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/kubofarm');
    }
     else if(current_heading === 'J・factory淡路屋'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/j-factory-awajiya');
    }
    else if(current_heading === '池本醤油合名会社'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/ikemoto-soy');
    }
    else if(current_heading === '梶浦養蜂園'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/kajiura-bee');
    }
    else if(current_heading === 'キョーエイ'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/kyoei');
    }
    else if(current_heading === '中上農場'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/nakauefarm');
    }
    else if(current_heading === '二方蒲鉾'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/futakata');
    }
    else if(current_heading === '畑特産物生産出荷組合'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/asakura-sansyo');
    }
    else if(current_heading === '田中屋食品'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/tanakaya');
    }
    else if(current_heading === '煙神'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/enjin');
    }
    else if(current_heading === '南あわじオリーヴ園'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/minamiawaji-olive-en');
    }
    else if(current_heading === '京都義の'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/yoshino');
    }
    else if(current_heading === '釣ヤ'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/tsuriya');
    }
    else if(current_heading === 'フレッシュつちやま'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/freshtuchiyama');
    }
    else if(current_heading === 'あわじっくす'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/awajix');
    }
    else if(current_heading === '淡路島ばぁむ工房 maaru factory'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/maaru-factory');
    }
    else if(current_heading === '本家熊野園'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/kumanoen');
    }
    else if(current_heading === 'アンジェロ'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/angelo');
    }
    else if(current_heading === '大和屋 旬果庵（大和青果）'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/daiwaya');
    }
    else if(current_heading === '円甘味'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/maruamami');
    }
    else if(current_heading === 'まるの農園'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/maruno');
    }
    else if(current_heading === '味噌本舗やまだ'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/misoyamada');
    }
    else if(current_heading === 'K.ファーム'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/k-farm');
    }
    else if(current_heading === 'N.Ground'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/n-ground');
      }
     else if(current_heading === '果樂'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/karaku');
      }
    else if(current_heading === '北山食品西神戸'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/kitayama');
      }
    else if(current_heading === '五斗長営農'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/gossa');
      }
    else if(current_heading === '名和甚'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/nawajin');
      }
    else if(current_heading === '元祖ぎょうざ苑'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/ganso-gyozaen');
      }
    else if(current_heading === '割烹おゝ浜'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/o-hama');
      }
    else if(current_heading === '勇希農園'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/yuki-farm');
      }
    else if(current_heading === '勤成丸'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/kinseimaru');
      }
    else if(current_heading === '鹿児島くみあい食品'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/kg-shoku');
      }
   else if(current_heading === 'NOUEN'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/nouen');
      }
   else if(current_heading === 'カニ工房まるや'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/maruya');
      }
   else if(current_heading === '泉佐野ファクトリー'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/hicom-farm');
      }
    else if(current_heading === '天の酒喰食房'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/amanojyaku');
      }
    else if(current_heading === 'KY田中農園'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/ky-tanaka-farm');
      }
    else if(current_heading === '食のかけはしカンパニー'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/fc-kakehashi');
      }
    else if(current_heading === 'ケンちゃんファーム'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/kenchanfarm');
      }
    else if(current_heading === '昇竜'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/kuzuryu');
      }
    else if(current_heading === '小川屋'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/niigata-ogawaya');
      }
     else if(current_heading === '山田海産物'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/kaisanbutsu');
      }
    else if(current_heading === '淡路ゆうき耕房'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/awajiyuukikoubou');
      }
      else if(current_heading === 'マンドリル'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/mandrillcurry');
      }
      else if(current_heading === 'やんばる原畑'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/harabatake');
      }
      else if(current_heading === 'Fujihara farm BASE'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/fujihara_farm');
      }
      else if(current_heading === '林農園'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/hayashi-farm');
      }
      else if(current_heading === '竹原物産'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/takeharabussan');
      }
      else if(current_heading === 'ポニーの里ファーム'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/ponynosato-farm');
      }
      else if(current_heading === '豊田農園'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/toyota-farm');
      }
       else if(current_heading === '豊光園'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/houkouen');
      }
       else if(current_heading === 'ヴィージェイ物産'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/buijiei');
      }
      else if(current_heading === 'MINORIBATAKE'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/minoribatake');
      }
       else if(current_heading === '山本商店'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/yamamotoshouten');
      }
      else if(current_heading === '美吉野ファーム'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/miyoshino-farm');
      }
       else if(current_heading === '山ちゃんファーム'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/yamachan-farm');
      }
       else if(current_heading === '六次産業アベイユ合同会社'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/abeiyu');
      }
       else if(current_heading === '国定農産'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/kunisadanosan');
      }
         else if(current_heading === 'やくもファーム'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/yakumo-farm');
      }
         else if(current_heading === '但馬漁業協同組合'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/tajima-gyogyo');
      }
         else if(current_heading === 'ひとやすみ'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/hitoyasumi');
      }
          else if(current_heading === 'ベジタンバ野菜ジェラート'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/bejitanba');
      }
          else if(current_heading === 'SAS'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/sas');
      }
          else if(current_heading === 'うまし楽苑'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/umashi');
      }
          else if(current_heading === '淡路島ぐるめ屋'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/awazisimagurumeya');
      }
          else if(current_heading === 'ヨコノ食品'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/yokonosyokuhin');
      }
          else if(current_heading === '梅香堂'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/baikado');
      }
          else if(current_heading === 'こうちファーム'){
      $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr('href', '/pages/kouchi-farm');
      }
    $('#shopify-section-template--15527731789992__1635306609e18ec13e .image-with-text__button').attr("target","_blank");
  }
}